export const cohortSort = (a, b, direction, column) => {
	if (direction === "asc") {
		return a[column] > b[column] ? 1 : -1;
	} else {
		return a[column] < b[column] ? 1 : -1;
	}
};

export const cohortNameSort = (a, b, direction) => {
	if (direction === "asc") {
		return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
	} else {
		return a.name.toLowerCase() < b.name.toLowerCase() ? 1 : -1;
	}
};

export const cohortTypeSort = (a, b, direction) => {
	if (direction === "asc") {
		return a.type > b.type ? 1 : -1;
	} else {
		return a.type < b.type ? 1 : -1;
	}
};

export const cohortStatusSort = (a, b, direction) => {
	if (direction === "asc") {
		return a.calculation_status > b.calculation_status ? 1 : -1;
	} else {
		return a.calculation_status < b.calculation_status ? 1 : -1;
	}
};

export const getCohortSort = (column: string) => {
	let sort = cohortSort;

	if (column === "name") {
		sort = cohortNameSort;
	} else if (column === "cohortType") {
		sort = cohortTypeSort;
	} else if (column === "status") {
		sort = cohortStatusSort;
	}

	return sort;
};

// This function sorts the list of cohorts, first by name, then by the chosen column.
// It also filters the list of cohorts by the search string.
// This means that after chosing a column, the cohorts list should be sorted by that column, but also alphabetized and filtered by the search string.
export const getSortedCohorts = (cohorts, column: string, direction: string, search: string) => {
	const sortCohortsColumnFunction = getCohortSort(column);

	return cohorts
		.filter((item) => {
			return item.name.toLowerCase().includes(search.trim().toLowerCase());
		})
		.sort((aName, bName) => {
			return cohortNameSort(aName, bName, "desc");
		})
		.sort((a, b) => {
			return sortCohortsColumnFunction(a, b, direction, column);
		});
};
